import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Controller} from 'react-hook-form'
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    Input,
    InputGroup,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {errorMessageStyle, labelInputStyle, labelNameStyle, labelStarStyle} from './index.style'
import {pxToRem} from '../../../../utills/pxToRem'

const GiftCardBalanceField = ({
    name,
    label,
    type = 'text',
    rules = {},
    error,
    placeholder,
    inputProps,
    control,
    autoComplete,
    defaultValue,
    helpText,
    children,
    inputRef,
    width = '100%'
}) => {
    const [hidePassword, setHidePassword] = useState(true)

    const inputType =
        type === 'password' && hidePassword ? 'password' : type === 'password' ? 'text' : type

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={defaultValue}
            render={({field: {onChange, value, ref}}) => {
                const _inputProps =
                    typeof inputProps === 'function' ? inputProps({value, onChange}) : inputProps

                return (
                    <FormControl
                        id={name}
                        isInvalid={error}
                        width={children ? 'auto' : width}
                        marginBottom={label == 'Enter your Gift Card Pin' ? '0' : pxToRem(20)}
                    >
                        <FormLabel sx={labelNameStyle}>
                            <Text sx={labelStarStyle}>*</Text>
                            {label}
                        </FormLabel>
                        <InputGroup>
                            <Input
                                ref={(node) => {
                                    ref(node)
                                    if (inputRef) inputRef.current = node
                                }}
                                onChange={(e) => {
                                    const val = e.target.value
                                    const filtered = val.replace(/[^0-9]/g, '')
                                    onChange(filtered)
                                }}
                                value={value}
                                type={inputType}
                                placeholder={placeholder}
                                autoComplete={autoComplete}
                                maxLength={label == 'Enter your Gift Card Pin' ? 4 : 19}
                                {..._inputProps}
                                isInvalid={!!error}
                                errorBorderColor="cav_red"
                                sx={labelInputStyle}
                            />
                            {children}
                        </InputGroup>

                        {error && type !== 'hidden' && (
                            <FormErrorMessage sx={errorMessageStyle}>
                                {error.message}
                            </FormErrorMessage>
                        )}

                        {helpText}
                    </FormControl>
                )
            }}
        />
    )
}

GiftCardBalanceField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    autoComplete: PropTypes.string,
    type: PropTypes.oneOf([
        'text',
        'number',
        'password',
        'email',
        'phone',
        'tel',
        'select',
        'checkbox',
        'hidden'
    ]),
    rules: PropTypes.object,
    error: PropTypes.shape({message: PropTypes.string}),
    placeholder: PropTypes.string,
    inputProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    control: PropTypes.object,
    defaultValue: PropTypes.any,
    helpText: PropTypes.any,
    children: PropTypes.any,
    inputRef: PropTypes.object,
    width: PropTypes.string
}

export default GiftCardBalanceField
